import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IChangePasswordForm, ICompany } from '@models/company';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CompanyApiService {
  private httpClient = inject(HttpClient);

  loadCompany(): Observable<ICompany> {
    return this.httpClient.get<ICompany>(`${environment.apiUrl}/companies/me`);
  }

  changeName(name: string): Observable<any> {
    return this.httpClient.put(`${environment.apiUrl}/companies/update`, null, {
      params: {
        name,
      },
    });
  }

  changePassword(data: IChangePasswordForm): Observable<any> {
    return this.httpClient.put(`${environment.apiUrl}/companies/password/change`, { ...data });
  }

  sendEmails(): Observable<void> {
    return this.httpClient.get<void>(`${environment.apiUrl}/license/emails/resend`);
  }
}
